import { SupportedCurrencies } from '../../redux/specialists/types';

export enum PossibleFlowType {
  'pay_first' = 'pay_first',
  'choose_time_first' = 'choose_time_first',
}
export interface StripeMetadataObjectType {
  userTimezone: string;
  userID?: string;
  consultationID: string;
  psychologistID?: string;
  consultationTime: string;
  videochatRoomID: string;
  subscriptionID?: string | null;
  amount: number;
}

export interface SavedCreditCardsType {
  brand: string;
  exp_month: number;
  exp_year: number;
  last4: string;
  paymentMethodId: string;
  isDefaultPaymentMethod: boolean;
}

export const StripeSupportedCurrency = [SupportedCurrencies.EUR, SupportedCurrencies.PLN, SupportedCurrencies.USD];

export type StripeResponseType = {
  secret: string;
  publishableKey: string;
  paymentIntentID: string;
  priceUAH: number;
  priceInCurrency: number;
  priceType: SupportedCurrencies;
  stripeChargeAmount: number;
  stripeChargeCurrency: (typeof StripeSupportedCurrency)[number];
};
